// This file is auto-generated by @hey-api/openapi-ts

export const TariffProfileTypesEnum = {
    SLIDING: 'SLIDING',
    CALENDAR: 'CALENDAR',
    FIXED: 'FIXED',
    SINGLE: 'SINGLE'
} as const;

export type TariffProfileTypesEnum = typeof TariffProfileTypesEnum[keyof typeof TariffProfileTypesEnum];
